/**
 * React Router NavLink `to` — `/#bölüm` için pathname + hash ayrıştırır.
 * @param {string} to
 * @returns {string | { pathname: string, hash?: string }}
 */
export function parseNavLinkTo(to) {
  const s = String(to ?? '').trim()
  if (s.startsWith('/#') && s.length > 2) {
    return { pathname: '/', hash: s.slice(2) }
  }
  return s
}
